"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  ComputerChipFlash: ['computer-chip-flash', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M10.7,21.126a.75.75,0,0,0-.75.75v1.25a.75.75,0,0,0,1.5,0v-1.25A.75.75,0,0,0,10.7,21.126Z', 'M14.2,21.126a.75.75,0,0,0-.75.75v1.25a.75.75,0,0,0,1.5,0v-1.25A.75.75,0,0,0,14.2,21.126Z', 'M10.7,7.126a.75.75,0,0,0,.75-.75V5.126a.75.75,0,0,0-1.5,0v1.25A.75.75,0,0,0,10.7,7.126Z', 'M7.2,21.126a.75.75,0,0,0-.75.75v1.25a.75.75,0,0,0,1.5,0v-1.25A.75.75,0,0,0,7.2,21.126Z', 'M7.2,7.126a.75.75,0,0,0,.75-.75V5.126a.75.75,0,0,0-1.5,0v1.25A.75.75,0,0,0,7.2,7.126Z', 'M20.051,17.376H18.8a.75.75,0,0,0,0,1.5h1.25a.75.75,0,0,0,0-1.5Z', 'M3.3,13.376H2.05a.75.75,0,1,0,0,1.5H3.3a.75.75,0,0,0,0-1.5Z', 'M20.051,13.376H18.8a.75.75,0,0,0,0,1.5h1.25a.75.75,0,0,0,0-1.5Z', 'M3.3,9.376H2.05a.75.75,0,1,0,0,1.5H3.3a.75.75,0,0,0,0-1.5Z', 'M3.3,17.376H2.05a.75.75,0,0,0,0,1.5H3.3a.75.75,0,0,0,0-1.5Z', 'M14.5,12.043a2.249,2.249,0,0,1-.5-2.853l.394-.69a.249.249,0,0,0-.217-.374H6.551a1.5,1.5,0,0,0-1.5,1.5v9a1.5,1.5,0,0,0,1.5,1.5h9a1.5,1.5,0,0,0,1.5-1.5V12.664a.25.25,0,0,0-.336-.235A2.244,2.244,0,0,1,14.5,12.043ZM7.551,16.626a.75.75,0,0,1,.75-.75h1.75a.75.75,0,1,1,0,1.5H8.3A.75.75,0,0,1,7.551,16.626Z', 'M22.638,4.779a1,1,0,0,0-.938-.653H20.592a.25.25,0,0,1-.184-.419L22.154,1.8A1,1,0,0,0,21.416.126H17.885a1,1,0,0,0-.923.615l-2.083,5A1,1,0,0,0,15.8,7.126h.678A.25.25,0,0,1,16.7,7.5L15.29,9.942a.75.75,0,0,0,1.134.948l5.927-5.006A1,1,0,0,0,22.638,4.779Z']],
  ComputerChipCore1: ['computer-chip-core-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M9.000 4.501 L15.000 4.501 L15.000 19.501 L9.000 19.501 Z', 'M21,9.5a1,1,0,1,0,0-2H19.25a.25.25,0,0,1-.25-.25v-1A.25.25,0,0,1,19.25,6H21a1,1,0,0,0,0-2H19.25a.25.25,0,0,1-.25-.25V1.5A1.5,1.5,0,0,0,17.5,0H6.5A1.5,1.5,0,0,0,5,1.5v2.25A.25.25,0,0,1,4.75,4H3A1,1,0,0,0,3,6H4.75a.25.25,0,0,1,.25.25v1a.25.25,0,0,1-.25.25H3a1,1,0,1,0,0,2H4.75a.25.25,0,0,1,.25.25v1a.25.25,0,0,1-.25.25H3a1,1,0,0,0,0,2H4.75a.25.25,0,0,1,.25.25v1a.25.25,0,0,1-.25.25H3a1,1,0,1,0,0,2H4.75a.25.25,0,0,1,.25.25v1a.25.25,0,0,1-.25.25H3a1,1,0,0,0,0,2H4.75a.25.25,0,0,1,.25.25V22.5A1.5,1.5,0,0,0,6.5,24h11A1.5,1.5,0,0,0,19,22.5v-2.25a.25.25,0,0,1,.25-.25H21a1,1,0,0,0,0-2H19.25a.25.25,0,0,1-.25-.25v-1a.25.25,0,0,1,.25-.25H21a1,1,0,0,0,0-2H19.25a.25.25,0,0,1-.25-.25v-1a.25.25,0,0,1,.25-.25H21a1,1,0,0,0,0-2H19.25a.25.25,0,0,1-.25-.25v-1a.25.25,0,0,1,.25-.25Zm-4.5-6v17a.5.5,0,0,1-.5.5H8a.5.5,0,0,1-.5-.5V3.5A.5.5,0,0,1,8,3h8A.5.5,0,0,1,16.5,3.5Z']],
  ComputerChipCore: ['computer-chip-core', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12.53,6.031a.749.749,0,0,1-1.06,0L9.763,4.324a.251.251,0,0,0-.177-.073H9.5a.25.25,0,0,0-.25.25v15a.25.25,0,0,0,.25.25h.086a.252.252,0,0,0,.177-.074L11.47,17.97a.749.749,0,0,1,1.06,0l1.707,1.707a.252.252,0,0,0,.177.074H14.5a.25.25,0,0,0,.25-.25V4.5a.25.25,0,0,0-.25-.25h-.086a.251.251,0,0,0-.177.073Z', 'M21,9.5a1,1,0,1,0,0-2H19.25a.25.25,0,0,1-.25-.25v-1A.25.25,0,0,1,19.25,6H21a1,1,0,0,0,0-2H19.25a.25.25,0,0,1-.25-.25V1.5A1.5,1.5,0,0,0,17.5,0H6.5A1.5,1.5,0,0,0,5,1.5v2.25A.25.25,0,0,1,4.75,4H3A1,1,0,0,0,3,6H4.75a.25.25,0,0,1,.25.25v1a.25.25,0,0,1-.25.25H3a1,1,0,1,0,0,2H4.75a.25.25,0,0,1,.25.25v1a.25.25,0,0,1-.25.25H3a1,1,0,0,0,0,2H4.75a.25.25,0,0,1,.25.25v1a.25.25,0,0,1-.25.25H3a1,1,0,1,0,0,2H4.75a.25.25,0,0,1,.25.25v1a.25.25,0,0,1-.25.25H3a1,1,0,0,0,0,2H4.75a.25.25,0,0,1,.25.25V22.5A1.5,1.5,0,0,0,6.5,24h11A1.5,1.5,0,0,0,19,22.5v-2.25a.25.25,0,0,1,.25-.25H21a1,1,0,0,0,0-2H19.25a.25.25,0,0,1-.25-.25v-1a.25.25,0,0,1,.25-.25H21a1,1,0,0,0,0-2H19.25a.25.25,0,0,1-.25-.25v-1a.25.25,0,0,1,.25-.25H21a1,1,0,0,0,0-2H19.25a.25.25,0,0,1-.25-.25v-1a.25.25,0,0,1,.25-.25Zm-4.75-6v17a.75.75,0,0,1-.75.75H14a.747.747,0,0,1-.53-.22l-1.293-1.293a.25.25,0,0,0-.354,0L10.53,21.031a.747.747,0,0,1-.53.22H8.5a.75.75,0,0,1-.75-.75V3.5a.75.75,0,0,1,.75-.75H10a.75.75,0,0,1,.53.219l1.293,1.293a.25.25,0,0,0,.354,0L13.47,2.97A.75.75,0,0,1,14,2.751h1.5A.75.75,0,0,1,16.25,3.5Z']],
  ComputerChip: ['computer-chip', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M2.435,11H1a1,1,0,0,0,0,2H2.435a1,1,0,1,0,0-2Z', 'M2.435,16H1a1,1,0,0,0,0,2H2.435a1,1,0,0,0,0-2Z', 'M2.435,6.5H1a1,1,0,1,0,0,2H2.435a1,1,0,1,0,0-2Z', 'M23,11H21.565a1,1,0,0,0,0,2H23a1,1,0,0,0,0-2Z', 'M21.565,8.5H23a1,1,0,0,0,0-2H21.565a1,1,0,0,0,0,2Z', 'M23,16H21.565a1,1,0,0,0,0,2H23a1,1,0,0,0,0-2Z', 'M12,3.435a1,1,0,0,0,1-1V1a1,1,0,0,0-2,0V2.435A1,1,0,0,0,12,3.435Z', 'M7.5,3.435a1,1,0,0,0,1-1V1a1,1,0,1,0-2,0V2.435A1,1,0,0,0,7.5,3.435Z', 'M16.5,3.435a1,1,0,0,0,1-1V1a1,1,0,0,0-2,0V2.435A1,1,0,0,0,16.5,3.435Z', 'M12,20.566a1,1,0,0,0-1,1V23a1,1,0,1,0,2,0V21.566A1,1,0,0,0,12,20.566Z', 'M16.5,20.566a1,1,0,0,0-1,1V23a1,1,0,1,0,2,0V21.566A1,1,0,0,0,16.5,20.566Z', 'M7.5,20.566a1,1,0,0,0-1,1V23a1,1,0,0,0,2,0V21.566A1,1,0,0,0,7.5,20.566Z', 'M18.067,4.5H5.933A1.435,1.435,0,0,0,4.5,5.934V18.067A1.436,1.436,0,0,0,5.933,19.5H18.067A1.436,1.436,0,0,0,19.5,18.067V5.934A1.435,1.435,0,0,0,18.067,4.5ZM16.5,15.5a1,1,0,0,1-1,1H13a1,1,0,0,1,0-2h2.5A1,1,0,0,1,16.5,15.5Z']],
  ComputerChip2: ['computer-chip-2', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M2.435,11H1a1,1,0,0,0,0,2H2.435a1,1,0,1,0,0-2Z', 'M2.435,16H1a1,1,0,0,0,0,2H2.435a1,1,0,0,0,0-2Z', 'M2.435,6.5H1a1,1,0,1,0,0,2H2.435a1,1,0,1,0,0-2Z', 'M23,11H21.565a1,1,0,0,0,0,2H23a1,1,0,0,0,0-2Z', 'M21.565,8.5H23a1,1,0,0,0,0-2H21.565a1,1,0,0,0,0,2Z', 'M23,16H21.565a1,1,0,0,0,0,2H23a1,1,0,0,0,0-2Z', 'M12,3.435a1,1,0,0,0,1-1V1a1,1,0,0,0-2,0V2.435A1,1,0,0,0,12,3.435Z', 'M7.5,3.435a1,1,0,0,0,1-1V1a1,1,0,1,0-2,0V2.435A1,1,0,0,0,7.5,3.435Z', 'M16.5,3.435a1,1,0,0,0,1-1V1a1,1,0,0,0-2,0V2.435A1,1,0,0,0,16.5,3.435Z', 'M12,20.566a1,1,0,0,0-1,1V23a1,1,0,1,0,2,0V21.566A1,1,0,0,0,12,20.566Z', 'M16.5,20.566a1,1,0,0,0-1,1V23a1,1,0,1,0,2,0V21.566A1,1,0,0,0,16.5,20.566Z', 'M7.5,20.566a1,1,0,0,0-1,1V23a1,1,0,0,0,2,0V21.566A1,1,0,0,0,7.5,20.566Z', 'M18.067,4.5H5.933A1.435,1.435,0,0,0,4.5,5.934V18.067A1.436,1.436,0,0,0,5.933,19.5H18.067A1.436,1.436,0,0,0,19.5,18.067V5.934A1.435,1.435,0,0,0,18.067,4.5Zm-4.442,9.25a.75.75,0,0,1,0,1.5H10.5a.75.75,0,0,1-.5-1.313l2.188-1.93c.66-.582.75-.7.667-1.108a.813.813,0,0,0-1.609.163.75.75,0,1,1-1.5,0,2.313,2.313,0,0,1,4.579-.462,2.39,2.39,0,0,1-1.088,2.481l-.262.231a.251.251,0,0,0,.165.438Z']],
  ComputerChip32: ['computer-chip-32', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M2.435,11H1a1,1,0,0,0,0,2H2.435a1,1,0,1,0,0-2Z', 'M2.435,16H1a1,1,0,0,0,0,2H2.435a1,1,0,0,0,0-2Z', 'M2.435,6.5H1a1,1,0,1,0,0,2H2.435a1,1,0,1,0,0-2Z', 'M23,11H21.565a1,1,0,0,0,0,2H23a1,1,0,0,0,0-2Z', 'M21.565,8.5H23a1,1,0,0,0,0-2H21.565a1,1,0,0,0,0,2Z', 'M24,17a1,1,0,0,0-1-1H21.565a1,1,0,0,0,0,2H23A1,1,0,0,0,24,17Z', 'M12,3.435a1,1,0,0,0,1-1V1a1,1,0,0,0-2,0V2.435A1,1,0,0,0,12,3.435Z', 'M7.5,3.435a1,1,0,0,0,1-1V1a1,1,0,1,0-2,0V2.435A1,1,0,0,0,7.5,3.435Z', 'M16.5,3.435a1,1,0,0,0,1-1V1a1,1,0,0,0-2,0V2.435A1,1,0,0,0,16.5,3.435Z', 'M12,20.566a1,1,0,0,0-1,1V23a1,1,0,1,0,2,0V21.566A1,1,0,0,0,12,20.566Z', 'M16.5,20.566a1,1,0,0,0-1,1V23a1,1,0,1,0,2,0V21.566A1,1,0,0,0,16.5,20.566Z', 'M7.5,20.566a1,1,0,0,0-1,1V23a1,1,0,0,0,2,0V21.566A1,1,0,0,0,7.5,20.566Z', 'M18.066,4.5H5.934A1.436,1.436,0,0,0,4.5,5.934V18.067A1.437,1.437,0,0,0,5.934,19.5H18.066A1.437,1.437,0,0,0,19.5,18.067V5.934A1.436,1.436,0,0,0,18.066,4.5Zm-8.691,8.25H8.438a.75.75,0,0,1,0-1.5h.937a.5.5,0,0,0,0-1H7.5a.75.75,0,1,1,0-1.5H9.375a2,2,0,0,1,1.662,3.111.251.251,0,0,0,0,.278,2,2,0,0,1-1.662,3.111H7.5a.75.75,0,1,1,0-1.5H9.375a.5.5,0,0,0,0-1Zm7.117,1a.75.75,0,0,1,0,1.5H13.367a.751.751,0,0,1-.5-1.313l2.188-1.93c.66-.583.751-.7.667-1.108a.813.813,0,0,0-1.609.163.75.75,0,0,1-1.5,0A2.312,2.312,0,0,1,17.2,10.6a2.39,2.39,0,0,1-1.087,2.482l-.262.231a.251.251,0,0,0,.166.438Z']],
  ComputerChip4: ['computer-chip-4', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M2.435,11H1a1,1,0,0,0,0,2H2.435a1,1,0,1,0,0-2Z', 'M2.435,16H1a1,1,0,0,0,0,2H2.435a1,1,0,0,0,0-2Z', 'M2.435,6.5H1a1,1,0,1,0,0,2H2.435a1,1,0,1,0,0-2Z', 'M23,11H21.565a1,1,0,0,0,0,2H23a1,1,0,0,0,0-2Z', 'M21.565,8.5H23a1,1,0,0,0,0-2H21.565a1,1,0,0,0,0,2Z', 'M23,16H21.565a1,1,0,0,0,0,2H23a1,1,0,0,0,0-2Z', 'M12,3.435a1,1,0,0,0,1-1V1a1,1,0,0,0-2,0V2.435A1,1,0,0,0,12,3.435Z', 'M7.5,3.435a1,1,0,0,0,1-1V1a1,1,0,1,0-2,0V2.435A1,1,0,0,0,7.5,3.435Z', 'M16.5,3.435a1,1,0,0,0,1-1V1a1,1,0,0,0-2,0V2.435A1,1,0,0,0,16.5,3.435Z', 'M12,20.566a1,1,0,0,0-1,1V23a1,1,0,1,0,2,0V21.566A1,1,0,0,0,12,20.566Z', 'M16.5,20.566a1,1,0,0,0-1,1V23a1,1,0,1,0,2,0V21.566A1,1,0,0,0,16.5,20.566Z', 'M7.5,20.566a1,1,0,0,0-1,1V23a1,1,0,0,0,2,0V21.566A1,1,0,0,0,7.5,20.566Z', 'M19.5,5.934A1.435,1.435,0,0,0,18.067,4.5H5.933A1.435,1.435,0,0,0,4.5,5.934V18.067A1.436,1.436,0,0,0,5.933,19.5H18.067A1.436,1.436,0,0,0,19.5,18.067ZM10,14.422a.75.75,0,0,1-.75-.75V13A3.944,3.944,0,0,1,13,8.9a.75.75,0,0,1,.75.75V15a.75.75,0,0,1-1.5,0v-.329a.25.25,0,0,0-.25-.25Z', 'M12.25,10.962a.25.25,0,0,0-.391-.206,2.655,2.655,0,0,0-1.088,1.886.251.251,0,0,0,.248.28H12a.25.25,0,0,0,.25-.25Z']],
  ComputerChip64: ['computer-chip-64', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M2.435,11H1a1,1,0,0,0,0,2H2.435a1,1,0,1,0,0-2Z', 'M2.435,16H1a1,1,0,0,0,0,2H2.435a1,1,0,0,0,0-2Z', 'M2.435,6.5H1a1,1,0,1,0,0,2H2.435a1,1,0,1,0,0-2Z', 'M24,12a1,1,0,0,0-1-1H21.565a1,1,0,0,0,0,2H23A1,1,0,0,0,24,12Z', 'M20.565,7.5a1,1,0,0,0,1,1H23a1,1,0,0,0,0-2H21.565A1,1,0,0,0,20.565,7.5Z', 'M23,16H21.565a1,1,0,0,0,0,2H23a1,1,0,0,0,0-2Z', 'M12,3.435a1,1,0,0,0,1-1V1a1,1,0,0,0-2,0V2.435A1,1,0,0,0,12,3.435Z', 'M7.5,3.435a1,1,0,0,0,1-1V1a1,1,0,1,0-2,0V2.435A1,1,0,0,0,7.5,3.435Z', 'M16.5,3.435a1,1,0,0,0,1-1V1a1,1,0,0,0-2,0V2.435A1,1,0,0,0,16.5,3.435Z', 'M12,20.566a1,1,0,0,0-1,1V23a1,1,0,1,0,2,0V21.566A1,1,0,0,0,12,20.566Z', 'M16.5,20.566a1,1,0,0,0-1,1V23a1,1,0,1,0,2,0V21.566A1,1,0,0,0,16.5,20.566Z', 'M7.5,20.566a1,1,0,0,0-1,1V23a1,1,0,0,0,2,0V21.566A1,1,0,0,0,7.5,20.566Z', 'M19.5,5.934A1.436,1.436,0,0,0,18.066,4.5H5.934A1.436,1.436,0,0,0,4.5,5.934V18.067A1.437,1.437,0,0,0,5.934,19.5H18.066A1.437,1.437,0,0,0,19.5,18.067ZM6.75,11.513A2.755,2.755,0,0,1,9.492,8.751h.332a.75.75,0,0,1,0,1.5H9.492a1.181,1.181,0,0,0-.849.359.25.25,0,0,0,.219.422A2.5,2.5,0,1,1,6.75,13.5ZM17.25,15a.75.75,0,0,1-1.5,0v-.329a.25.25,0,0,0-.25-.25h-2a.75.75,0,0,1-.75-.75V13A3.945,3.945,0,0,1,16.5,8.9a.75.75,0,0,1,.75.75Z', 'M8.250 13.501 A1.000 1.000 0 1 0 10.250 13.501 A1.000 1.000 0 1 0 8.250 13.501 Z', 'M14.271,12.642a.251.251,0,0,0,.248.28H15.5a.25.25,0,0,0,.25-.25v-1.71a.25.25,0,0,0-.391-.206A2.655,2.655,0,0,0,14.271,12.642Z']],
  MicrochipBoard: ['microchip-board', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.5,0H1.5A1.5,1.5,0,0,0,0,1.5v21A1.5,1.5,0,0,0,1.5,24h21A1.5,1.5,0,0,0,24,22.5V1.5A1.5,1.5,0,0,0,22.5,0ZM18,16a1,1,0,1,1,1-1A1,1,0,0,1,18,16Zm1,2.5a1,1,0,1,1-1-1A1,1,0,0,1,19,18.5Zm-1-6a1,1,0,1,1,1-1A1,1,0,0,1,18,12.5Zm-2-5a.5.5,0,0,1,0-1h4.5a.5.5,0,0,1,0,1ZM20.5,4h-6a.5.5,0,1,1,0-1h6a.5.5,0,0,1,0,1Zm-6.75,9.75h-.5a.5.5,0,0,1,0-1h.5a.5.5,0,0,1,0,1Zm.5,2.5a.5.5,0,0,1-.5.5h-.5a.5.5,0,0,1,0-1h.5A.5.5,0,0,1,14.249,16.251Zm-8.75,2a.5.5,0,0,1-.5-.5v-6a.5.5,0,0,1,.5-.5h6a.5.5,0,0,1,.5.5v6a.5.5,0,0,1-.5.5Zm5,1.25V20a.5.5,0,0,1-1,0v-.5a.5.5,0,0,1,1,0Zm-3,0V20a.5.5,0,0,1-1,0v-.5a.5.5,0,0,1,1,0Zm-3.749-5.75h-.5a.5.5,0,1,1,0-1h.5a.5.5,0,1,1,0,1Zm.5,2.5a.5.5,0,0,1-.5.5h-.5a.5.5,0,0,1,0-1h.5A.5.5,0,0,1,4.251,16.251ZM3.5,4a.5.5,0,0,1,0-1h6a.5.5,0,0,1,0,1Zm7,5.5V10a.5.5,0,0,1-1,0V9.5a.5.5,0,1,1,1,0Zm-3,0V10a.5.5,0,0,1-1,0V9.5a.5.5,0,1,1,1,0Z', 'M6.5,12.35a.4.4,0,0,0-.4.4v4a.4.4,0,0,0,.4.4h4a.4.4,0,0,0,.4-.4v-4a.4.4,0,0,0-.4-.4Zm3.6,3.75a.25.25,0,0,1-.25.25H7.15a.25.25,0,0,1-.25-.25V13.4a.25.25,0,0,1,.25-.25h2.7a.25.25,0,0,1,.25.25Z']],
  ComputerChipShield: ['computer-chip-shield', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M2.435,11H1a1,1,0,0,0,0,2H2.435a1,1,0,1,0,0-2Z', 'M2.435,16H1a1,1,0,0,0,0,2H2.435a1,1,0,0,0,0-2Z', 'M2.435,6.5H1a1,1,0,1,0,0,2H2.435a1,1,0,1,0,0-2Z', 'M23,11H21.565a1,1,0,0,0,0,2H23a1,1,0,0,0,0-2Z', 'M21.565,8.5H23a1,1,0,0,0,0-2H21.565a1,1,0,0,0,0,2Z', 'M24,17a1,1,0,0,0-1-1H21.565a1,1,0,0,0,0,2H23A1,1,0,0,0,24,17Z', 'M12,3.435a1,1,0,0,0,1-1V1a1,1,0,0,0-2,0V2.435A1,1,0,0,0,12,3.435Z', 'M7.5,3.435a1,1,0,0,0,1-1V1a1,1,0,1,0-2,0V2.435A1,1,0,0,0,7.5,3.435Z', 'M16.5,3.435a1,1,0,0,0,1-1V1a1,1,0,0,0-2,0V2.435A1,1,0,0,0,16.5,3.435Z', 'M12,20.566a1,1,0,0,0-1,1V23a1,1,0,1,0,2,0V21.566A1,1,0,0,0,12,20.566Z', 'M16.5,20.566a1,1,0,0,0-1,1V23a1,1,0,1,0,2,0V21.566A1,1,0,0,0,16.5,20.566Z', 'M7.5,20.566a1,1,0,0,0-1,1V23a1,1,0,0,0,2,0V21.566A1,1,0,0,0,7.5,20.566Z', 'M18.067,4.5H5.933A1.435,1.435,0,0,0,4.5,5.934V18.067A1.436,1.436,0,0,0,5.933,19.5H18.067A1.436,1.436,0,0,0,19.5,18.067V5.934A1.435,1.435,0,0,0,18.067,4.5Zm-1.491,4c0,3.2-.49,7.063-4.311,8.506a.756.756,0,0,1-.53,0C7.17,15.283,7.424,9.907,7.424,8.5a.75.75,0,0,1,.75-.75h7.652A.75.75,0,0,1,16.576,8.5Z', 'M13.338,9.7a.249.249,0,0,0-.157-.444H9.193a.25.25,0,0,0-.18.077.245.245,0,0,0-.07.183,11.29,11.29,0,0,0,.458,2.92.252.252,0,0,0,.167.163.249.249,0,0,0,.229-.045Z', 'M10.45,13.949a.25.25,0,0,0-.034.356,4.332,4.332,0,0,0,1.477,1.142.251.251,0,0,0,.214,0c1.857-.874,2.573-2.627,2.832-4.562a.25.25,0,0,0-.4-.228Z']],
  ComputerChipFire: ['computer-chip-fire', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M11.2,21.126a.75.75,0,0,0-.75.75v1.25a.75.75,0,0,0,1.5,0v-1.25A.75.75,0,0,0,11.2,21.126Z', 'M14.7,21.126a.75.75,0,0,0-.75.75v1.25a.75.75,0,0,0,1.5,0v-1.25A.75.75,0,0,0,14.7,21.126Z', 'M11.2,7.126a.75.75,0,0,0,.75-.75V5.126a.75.75,0,0,0-1.5,0v1.25A.75.75,0,0,0,11.2,7.126Z', 'M7.7,21.126a.75.75,0,0,0-.75.75v1.25a.75.75,0,1,0,1.5,0v-1.25A.75.75,0,0,0,7.7,21.126Z', 'M7.7,7.126a.75.75,0,0,0,.75-.75V5.126a.75.75,0,0,0-1.5,0v1.25A.75.75,0,0,0,7.7,7.126Z', 'M20.551,17.376H19.3a.75.75,0,0,0,0,1.5h1.25a.75.75,0,0,0,0-1.5Z', 'M3.8,13.376H2.55a.75.75,0,1,0,0,1.5H3.8a.75.75,0,0,0,0-1.5Z', 'M20.551,13.376H19.3a.75.75,0,0,0,0,1.5h1.25a.75.75,0,0,0,0-1.5Z', 'M3.8,9.376H2.55a.75.75,0,1,0,0,1.5H3.8a.75.75,0,0,0,0-1.5Z', 'M3.8,17.376H2.55a.75.75,0,0,0,0,1.5H3.8a.75.75,0,0,0,0-1.5Z', 'M12.956,8.3a.25.25,0,0,0-.238-.175H7.051a1.5,1.5,0,0,0-1.5,1.5v9a1.5,1.5,0,0,0,1.5,1.5h9a1.5,1.5,0,0,0,1.5-1.5V12.3a.248.248,0,0,0-.211-.246A5.5,5.5,0,0,1,12.956,8.3Zm-4.9,8.325a.75.75,0,0,1,.75-.75h1.75a.75.75,0,1,1,0,1.5H8.8A.75.75,0,0,1,8.051,16.626Z', 'M17,.139a.494.494,0,0,0-.566.281.5.5,0,0,0,.161.61,2.859,2.859,0,0,1,1.074,2.556.142.142,0,0,1-.283.006.5.5,0,0,0-.239-.372.507.507,0,0,0-.44-.037,3.653,3.653,0,0,0-2.5,3.489,4,4,0,0,0,8,0A6.826,6.826,0,0,0,17,.139Z']],
  ComputerChipSearch: ['computer-chip-search', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M-.03,10.975a10.979,10.979,0,0,0,17.32,8.984.5.5,0,0,1,.643.056l3.537,3.572a1.5,1.5,0,0,0,2.121-2.121l-3.548-3.584a.5.5,0,0,1-.054-.637A10.993,10.993,0,1,0-.03,10.975Zm11-9a9,9,0,1,1-9,9A9.01,9.01,0,0,1,10.97,1.975Z', 'M5.97,11.715a.75.75,0,1,0,0,1.5h.75a.25.25,0,0,1,.25.25v.5a1,1,0,0,0,1,1h.5a.25.25,0,0,1,.25.25v.75a.75.75,0,0,0,1.5,0v-.75a.25.25,0,0,1,.25-.25h1a.25.25,0,0,1,.25.25v.75a.75.75,0,0,0,1.5,0v-.75a.25.25,0,0,1,.25-.25h.5a1,1,0,0,0,1-1v-.5a.25.25,0,0,1,.25-.25h.75a.75.75,0,1,0,0-1.5h-.75a.25.25,0,0,1-.25-.25v-1a.25.25,0,0,1,.25-.25h.75a.75.75,0,1,0,0-1.5h-.75a.25.25,0,0,1-.25-.25v-.5a1,1,0,0,0-1-1h-.5a.25.25,0,0,1-.25-.25v-.75a.75.75,0,0,0-1.5,0v.75a.25.25,0,0,1-.25.25h-1a.25.25,0,0,1-.25-.25v-.75a.75.75,0,0,0-1.5,0v.75a.25.25,0,0,1-.25.25h-.5a1,1,0,0,0-1,1v.5a.25.25,0,0,1-.25.25H5.97a.75.75,0,1,0,0,1.5h.75a.25.25,0,0,1,.25.25v1a.25.25,0,0,1-.25.25Z']],
  ComputerChip8: ['computer-chip-8', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M2.435,11H1a1,1,0,0,0,0,2H2.435a1,1,0,1,0,0-2Z', 'M2.435,16H1a1,1,0,0,0,0,2H2.435a1,1,0,0,0,0-2Z', 'M2.435,6.5H1a1,1,0,1,0,0,2H2.435a1,1,0,1,0,0-2Z', 'M23,11H21.565a1,1,0,0,0,0,2H23a1,1,0,0,0,0-2Z', 'M21.565,8.5H23a1,1,0,0,0,0-2H21.565a1,1,0,0,0,0,2Z', 'M23,16H21.565a1,1,0,0,0,0,2H23a1,1,0,0,0,0-2Z', 'M12,3.435a1,1,0,0,0,1-1V1a1,1,0,0,0-2,0V2.435A1,1,0,0,0,12,3.435Z', 'M7.5,3.435a1,1,0,0,0,1-1V1a1,1,0,1,0-2,0V2.435A1,1,0,0,0,7.5,3.435Z', 'M16.5,3.435a1,1,0,0,0,1-1V1a1,1,0,0,0-2,0V2.435A1,1,0,0,0,16.5,3.435Z', 'M12,20.566a1,1,0,0,0-1,1V23a1,1,0,1,0,2,0V21.566A1,1,0,0,0,12,20.566Z', 'M16.5,20.566a1,1,0,0,0-1,1V23a1,1,0,1,0,2,0V21.566A1,1,0,0,0,16.5,20.566Z', 'M7.5,20.566a1,1,0,0,0-1,1V23a1,1,0,0,0,2,0V21.566A1,1,0,0,0,7.5,20.566Z', 'M19.5,5.934A1.435,1.435,0,0,0,18.067,4.5H5.933A1.435,1.435,0,0,0,4.5,5.934V18.067A1.436,1.436,0,0,0,5.933,19.5H18.067A1.436,1.436,0,0,0,19.5,18.067ZM9.75,10a2.25,2.25,0,0,1,4.5,0,2.2,2.2,0,0,1-.374,1.223.25.25,0,0,0,.035.318A2.718,2.718,0,0,1,14.75,13.5a2.75,2.75,0,0,1-5.5,0,2.718,2.718,0,0,1,.839-1.959.251.251,0,0,0,.035-.318A2.2,2.2,0,0,1,9.75,10Z', 'M11.250 10.001 A0.750 0.750 0 1 0 12.750 10.001 A0.750 0.750 0 1 0 11.250 10.001 Z', 'M10.750 13.501 A1.250 1.250 0 1 0 13.250 13.501 A1.250 1.250 0 1 0 10.750 13.501 Z']]
};
exports["default"] = _default;